"use client";

import { useLocale } from "next-intl";
import React, { type ReactElement, ElementType } from "react";
import {
  FeatureCard,
  FeatureCardContent,
  FeatureCardDescription,
  FeatureCardLink,
  FeatureCardTitle,
  FeatureCardImage,
} from "@/components";
import { ICONS } from "@/services/applications";
import type { Application } from "@/types";

interface GlobalApplicationCard {
  application: Application;
}

function GlobalApplicationCard({
  application,
}: Readonly<GlobalApplicationCard>): ReactElement | null {
  const locale = useLocale();
  const Icon = ICONS[application.icon] as ElementType;
  const lead = application.lead ? application.lead[locale] : null;
  return (
    <FeatureCard className="relative flex-1 border rounded-xl hover:bg-secondary hover:ring-1">
      <FeatureCardContent className="z-10 flex-1 mt-24">
        <FeatureCardTitle className="flex flex-col">
          {application.title[locale]}
        </FeatureCardTitle>
        {lead ? (
          <FeatureCardDescription className="w-3/4 opacity-80">
            {lead}
          </FeatureCardDescription>
        ) : null}
        <FeatureCardLink href={application.url} />
      </FeatureCardContent>
      <FeatureCardImage className="items-start justify-start p-6">
        <Icon size={80} strokeWidth={0.2} />
      </FeatureCardImage>
    </FeatureCard>
  );
}

export { GlobalApplicationCard };
